import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    request_failed: false,
    loading: false
  },
  mutations: {
    SET_REQUEST_FAILED: (state, payload) => {
      state['request_failed'] = payload
    },
    SET_LOADING: (state, payload) => {
      state['loading'] = payload
    }
  },
  actions: {},
  getters: {
    requestFailed (state) {
      return state['request_failed']
    },
    loading (state) {
      return state['loading']
    }
  }
})
